import * as yup from 'yup';
import { withFormik } from "formik";
import SparkTelephonyDetails from './SparkTelephonyDetails';
import { TelephonyDeploymentResponse } from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentResponse';
import TelephonyDeploymentRequest from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentRequest';
import { defaultVoice } from '../../../../shared/constants/sparkConstants/voices';
import { defaultTelephonyDeploymentSettings } from '../../../../shared/constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings';

export interface SparkTelephonyDetailsProps {
    selectedTelephonyDeployment: TelephonyDeploymentResponse
    allTelephonyDeployments?: TelephonyDeploymentResponse[]
    handleSubmitTelephonyForm: (phoneNumber: string, telephonyDeploymentRequest: TelephonyDeploymentRequest) => void
    isLoadingTelephonyDeployments: boolean
    loadTelephonyDeployments: () => void
}

export interface SparkTelephonyDetailsFormData {
    callRecordingEnabled: boolean
    ttsOptions: [{ ttsVoice: string, ttsProvider: string }]
    virtualNumber?: string
    useVirtualNumber?: boolean
    performLanguageDetection?: boolean
    dtmfTurnsToListen?: number
}

const SparkTelephonyDetailsForm = withFormik<SparkTelephonyDetailsProps, SparkTelephonyDetailsFormData>({
    mapPropsToValues: (props) => ({
        callRecordingEnabled: props.selectedTelephonyDeployment?.callRecordingEnabled ?? false,
        ttsOptions: props.selectedTelephonyDeployment?.ttsOptions ?? defaultTelephonyDeploymentSettings.ttsOptions,
        virtualNumber: props.selectedTelephonyDeployment?.virtualNumber,
        performLanguageDetection: props.selectedTelephonyDeployment?.performLanguageDetection ?? defaultTelephonyDeploymentSettings.performLanguageDetection,
        dtmfTurnsToListen: props.selectedTelephonyDeployment?.dtmfTurnsToListen ?? defaultTelephonyDeploymentSettings.dtmfTurnsToListen
    }),
    validationSchema: yup.object().shape({
        callRecordingEnabled: yup.boolean().required(),
        ttsOptions: yup.object().required(),
        virtualNumber: yup.string().required().max(50),
        performLanguageDetection: yup.boolean(),
        dtmfTurnsToListen: yup.number().min(0, "Must be a number 0 or greater")
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
        setSubmitting(true);
    }
})(SparkTelephonyDetails);

export default SparkTelephonyDetailsForm;